export default "__VITE_ASSET__y74t6KzW__"